
    import './styles.scoped.css';
    export default {
  "root": "_root_46iav_3",
  "recovery": "_recovery_46iav_15"
};
  